import React from "react";
import { Box } from "app/components/common";
import i18n from "@microdoing/shared/i18n";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import WenIcon from "app/components/Icons/Search/WenIcon";
import normalize from "app/utils/normalize";
import theme from "app/Theme/Theme";
import { TextInput } from "react-native";

interface Props {
  value: string;
  setSearch: (search: string) => void;
  placeholder?: string;
}

const MbtiSearchInput = ({
  value,
  setSearch,
  placeholder = i18n.t("search"),
}: Props) => {
  return (
    <Box
      backgroundColor="neutral.50"
      padding="s"
      paddingLeft="xs"
      borderRadius={200}
      marginVertical="sm"
      marginBottom={!isWebDesktop ? "s" : "null"}
      width={isWebDesktop ? "100%" : "96%"}
      flexDirection="row"
      alignItems="center"
      justifyContent="flex-start"
      alignSelf="center"
    >
      <WenIcon
        height={normalize(20)}
        width={normalize(20)}
        color={theme.colors["neutral.600"]}
      />
      <TextInput
        testID="search-input"
        textAlignVertical="center"
        style={{
          flex: 1,
          color: theme.colors["neutral.900"],
          paddingHorizontal: theme.spacing.xs,
          ...theme.body["l4-medium"],
          height: "100%",
          outline: isWebDesktop ? "transparent" : undefined,
        }}
        onChangeText={e => {
          setSearch(e);
        }}
        value={value}
        placeholder={placeholder}
        placeholderTextColor={theme.colors["neutral.600"]}
        spellCheck={false}
        autoCorrect={false}
        autoCapitalize="none"
        autoFocus={false}
      />
    </Box>
  );
};

export default MbtiSearchInput;
